import { createStore, applyMiddleware } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';

import createSagaMiddleware from 'redux-saga';

import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import RootReducer from './root-reducer';
import RootSaga from './root-saga';

import logger from 'redux-logger'

const sagaMiddleware = createSagaMiddleware();

const history = createHistory();

const historyMiddleware = routerMiddleware(history);

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

const Store = applyMiddleware(promiseMiddleware(), sagaMiddleware, historyMiddleware)(createStore)(RootReducer, devTools);

sagaMiddleware.run(RootSaga);

export default Store;

export { history };



// WEBPACK FOOTER //
// ./src/config/redux-store.js